(function () {
  const ctrl = {
    $blocks: [],
    $slots: [],
    activeIndex: 0,

    init() {
      this.$blocks = Array.from(document.querySelectorAll('.tjh_ppc_multipage_form_block'));
      if (!this.$blocks.length) return;

      this.$slots = this.$blocks
        .map(($b) => $b.querySelector('[data-form-slot]'))
        .filter(Boolean);

      if (!this.$slots.length || !this.getForm()) return;

      this.setUpFormMode();
      this.setUpSlotListeners();
      this.setUpSubmitLoading();
      this.setUpSubmitWatch();
      this.setUpSizeLock();

      if (this.$blocks.length > 1) this.setUpScrollSwap();
    },

    getForm() {
      for (const $s of this.$slots) {
        const $f = $s.querySelector('.frm_forms');
        if ($f) return $f;
      }
      return null;
    },

    isAutoAdvancePage($page) {
      if (!$page) return false;
      return Boolean(
        $page.querySelector('.frm_image_options')
        || $page.querySelector('.frm_opt_container input[type="radio"]')
      );
    },

    setUpFormMode() {
      const $form = this.getForm();
      if (!$form) return;
      const $firstPage = $form.querySelector('.frm_page_num_1');
      if (!this.isAutoAdvancePage($firstPage)) return;
      $form.classList.add('has_auto_advance_first_page');
    },

    setUpSlotListeners() {
      this.$slots.forEach(($slot) => {
        $slot.addEventListener('change', (e) => {
          if (!e.target || e.target.type !== 'radio') return;
          const $form = $slot.querySelector('.frm_forms');
          if (!$form) return;
          const $firstPage = $form.querySelector('.frm_page_num_1');
          if (!$firstPage || !this.isAutoAdvancePage($firstPage)) return;
          if (!$firstPage.contains(e.target)) return;
          const $next = $firstPage.querySelector('.frm_button_submit');
          if ($next) $next.click();
        });
      });
    },

    setUpSubmitLoading() {
      this.$slots.forEach(($slot) => {
        $slot.addEventListener('click', (e) => {
          const $btn = e.target.closest('.frm_button_submit');
          if (!$btn || !$slot.contains($btn)) return;
          $btn.classList.add('is_loading');
        });
      });
    },

    setUpSubmitWatch() {
      const check = () => {
        const submitted = this.$slots.some(($s) => $s.querySelector('.frm_message'));
        if (submitted) this.markSubmitted();
      };

      this.$slots.forEach(($slot) => {
        new MutationObserver(check).observe($slot, { childList: true, subtree: true });
      });
      check();
    },

    setUpSizeLock() {
      const lock = () => {
        const $form = this.getForm();
        if (!$form) return false;
        const h = $form.getBoundingClientRect().height;
        if (!h) return false;
        this.$slots.forEach(($s) => {
          // $s.style.setProperty('--form-slot-min-height', `${h}px`);
        });
        return true;
      };

      if (lock()) return;
      window.addEventListener('load', () => {
        if (lock()) return;
        requestAnimationFrame(lock);
      }, { once: true });
    },

    setUpScrollSwap() {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = this.$blocks.indexOf(entry.target);
          if (index === -1 || index === this.activeIndex) return;
          this.moveTo(index);
        });
      }, { threshold: 0.01 });

      this.$blocks.forEach(($b) => io.observe($b));
    },

    moveTo(index) {
      const $target = this.$slots[index];
      if (!$target) return;
      const $form = this.getForm();
      if (!$form || $target.contains($form)) return;
      $target.appendChild($form);
      this.activeIndex = index;
    },

    markSubmitted() {
      this.$blocks.forEach(($b) => {
        const $colRight = $b.querySelector('.col.right');
        if ($colRight) $colRight.classList.add('form_submitted');
      });
    }
  };

  ctrl.init();
})();
